import React from 'react';
import styled from 'styled-components';
import { Text } from "../Text";
import { IconFiletypeAudio } from "@frameio/vapor-icons/build/esm/icons/IconFiletypeAudio";
import { IconFiletypeBlank } from "@frameio/vapor-icons/build/esm/icons/IconFiletypeBlank";
import { IconFiletypeCompressed } from "@frameio/vapor-icons/build/esm/icons/IconFiletypeCompressed";
import { IconFiletypeImage } from "@frameio/vapor-icons/build/esm/icons/IconFiletypeImage";
import { IconFiletypePdf } from "@frameio/vapor-icons/build/esm/icons/IconFiletypePdf";
import { IconFiletypeSpreadsheet } from "@frameio/vapor-icons/build/esm/icons/IconFiletypeSpreadsheet";
import { IconFiletypeText } from "@frameio/vapor-icons/build/esm/icons/IconFiletypeText";
import { IconFiletypeVideo } from "@frameio/vapor-icons/build/esm/icons/IconFiletypeVideo";
import { IconFolder } from "@frameio/vapor-icons/build/esm/icons/IconFolder";
import { IconProject } from "@frameio/vapor-icons/build/esm/icons/IconProject";
var StyledText = styled(Text).withConfig({
  displayName: "getIconConfigForAsset__StyledText",
  componentId: "vapor__lp8ici-0"
})(["pointer-events:none;user-select:none;"]);

var getIconLikeComponent = function getIconLikeComponent() {
  var displayText = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return function () {
    return /*#__PURE__*/React.createElement(StyledText, null, displayText);
  };
};

var _iconConfigByTypeName = {
  AudioAsset: {
    Icon: IconFiletypeAudio,
    color: 'audio',
    backgroundColor: 'audio',
    displayText: 'audio'
  },
  DocumentAsset: {
    Icon: IconFiletypeText,
    color: 'text',
    backgroundColor: 'text',
    displayText: 'text'
  },
  FileAsset: {
    Icon: IconFiletypeBlank,
    color: 'blank',
    backgroundColor: 'blank',
    displayText: 'file'
  },
  FolderAsset: {
    Icon: IconFolder,
    color: 'blank',
    backgroundColor: 'blank',
    displayText: 'folder'
  },
  ImageAsset: {
    Icon: IconFiletypeImage,
    color: 'image',
    backgroundColor: 'image',
    displayText: 'image'
  },
  Project: {
    Icon: IconProject,
    color: 'blank',
    backgroundColor: 'blank',
    displayText: 'project'
  },
  VideoAsset: {
    Icon: IconFiletypeVideo,
    color: 'video',
    backgroundColor: 'video',
    displayText: 'video'
  },
  UnsupportedAsset: {
    Icon: IconFiletypeBlank,
    color: 'blank',
    backgroundColor: 'blank',
    displayText: 'unknown'
  }
};
var _iconConfigByMimeType = {
  'application/msword': {
    Icon: IconFiletypeText,
    color: 'text',
    backgroundColor: 'text',
    displayText: 'word'
  },
  'application/pdf': {
    Icon: IconFiletypePdf,
    color: 'pdf',
    backgroundColor: 'pdf',
    displayText: 'pdf'
  },
  'application/vnd.adobe.aftereffects.project': {
    Icon: getIconLikeComponent('Ae'),
    color: 'motion',
    backgroundColor: 'motion',
    displayText: 'ae'
  },
  'application/vnd.adobe.aftereffects.template': {
    Icon: getIconLikeComponent('Ae'),
    color: 'motion',
    backgroundColor: 'motion',
    displayText: 'ae'
  },
  'application/vnd.audiograph': {
    Icon: getIconLikeComponent('Ae'),
    color: 'motion',
    backgroundColor: 'motion',
    displayText: 'ae'
  },
  'application/vnd.ms-excel': {
    Icon: IconFiletypeSpreadsheet,
    color: 'spreadsheet',
    backgroundColor: 'spreadsheet',
    displayText: 'xls'
  },
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': {
    Icon: IconFiletypeSpreadsheet,
    color: 'spreadsheet',
    backgroundColor: 'spreadsheet',
    displayText: 'xls'
  },
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': {
    Icon: IconFiletypeText,
    color: 'text',
    backgroundColor: 'text',
    displayText: 'word'
  },
  'application/zip': {
    Icon: IconFiletypeCompressed,
    color: 'compressed',
    backgroundColor: 'compressed',
    displayText: 'zip'
  }
};
export var getIconConfigForAsset = function getIconConfigForAsset(_ref) {
  var assetTypename = _ref.assetTypename,
      mimeType = _ref.mimeType;
  return _iconConfigByMimeType[mimeType] || _iconConfigByTypeName[assetTypename];
};